export function formatarCnpj(cnpj: string): string | null {
  if (!cnpj) {
    return null;
  }

  const cnpjLimpo = cnpj.replace(/[^a-zA-Z0-9]/g, '');
  if (cnpjLimpo.length === 14) {
    return cnpjLimpo.replace(/^([a-zA-Z0-9]{2})([a-zA-Z0-9]{3})([a-zA-Z0-9]{3})([a-zA-Z0-9]{4})([a-zA-Z0-9]{2})$/, '$1.$2.$3/$4-$5').toUpperCase();
  }

  return null;
}
